import DotsHorizontalIcon from '@eduzz/houston-icons/DotsHorizontal';
import IconButton from '@eduzz/houston-ui/IconButton';
import React from 'react';

type TableActionButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

function TableActionButton({ onClick, disabled }: TableActionButtonProps) {
  return (
    <IconButton onClick={onClick} disabled={disabled}>
      <DotsHorizontalIcon />
    </IconButton>
  );
}

export { TableActionButton };
